// extracted by mini-css-extract-plugin
export default {"page":"LogoutPage_page__MxJx7","logoutPage":"LogoutPage_logoutPage__Oy0Io","logoutCard":"LogoutPage_logoutCard__b4yr6"};